<template>
    <div>
      <div v-if="optimizationLevel">
        {{ optimizationLevelOptions.filter(option => option.value === optimizationLevel)?.[0].text }}
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not selected
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewOptimizationLevel',
    props: [
        'optimizationLevelOptions',
        'optimizationLevel',
    ],
}
</script>

<style lang="scss" scoped>

</style>